import { render, staticRenderFns } from "./BIMCamera.vue?vue&type=template&id=1c3fa4ce&scoped=true&"
import script from "./BIMCamera.vue?vue&type=script&lang=js&"
export * from "./BIMCamera.vue?vue&type=script&lang=js&"
import style0 from "./BIMCamera.vue?vue&type=style&index=0&id=1c3fa4ce&lang=scss&scoped=true&"
import style1 from "./BIMCamera.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3fa4ce",
  null
  
)

export default component.exports